import {
    Content,
    TextContainer,
    Title,
    SubTitle,
    Description,
    StoreBadge,
    CarouselContainer,
} from './styles';
import { appStoreURL } from '../../constants/urls';
import Carousel from '../Carousel';

const Home = () => {
    return (
        <Content>
            <TextContainer>
                <Title>LiftMore</Title>
                <SubTitle>Track every rep. Own your progress.</SubTitle>
                <Description>LiftMore is a strength training tracker for iPhone. Log sets, track PRs, and visualize your progress with charts and stats. No clutter, no subscription.</Description>
                <a href={appStoreURL}><StoreBadge src="assets/Download_on_the_App_Store_Badge.svg" /></a>
            </TextContainer>
            <CarouselContainer>
                <Carousel />
            </CarouselContainer>
        </Content>
    );
}

export default Home;
